
/**
 * SEO 配置 - models (한국어)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - 플래그십 AI 비디오 생성기 | WeryAI',
        description: 'Google Veo 3.1: 네이티브 오디오와 프레임 컨트롤을 갖춘 플래그십 AI 비디오 모델.',
        keywords: 'Google Veo 3.1, 플래그십 AI 비디오, AI 비디오 생성기, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - 고품질 AI 비디오 생성 | WeryAI',
        description: 'Google Veo 3로 고품질 AI 비디오를 생성하세요. 강력한 모션 일관성과 네이티브 오디오 지원.',
        keywords: 'Veo 3, Google Veo, AI 비디오 제작, 텍스트 투 비디오, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - 초고속 AI 비디오 생성 | WeryAI',
        description: 'Google Veo 3 Fast로 빠르게 고화질 AI 비디오를 생성하세요. 캐릭터 일관성과 초고속 렌더링 지원.',
        keywords: 'Veo 3 Fast, 초고속 AI 비디오, 캐릭터 일관성, 텍스트 투 비디오, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - 물리 시뮬레이션급 AI 비디오 생성 | WeryAI',
        description: 'OpenAI Sora 2로 물리 법칙에 부합하는 초현실적인 비디오를 생성하세요. 멀티샷 내러티브와 정밀 제어 지원.',
        keywords: 'Sora 2, OpenAI Sora, 물리 시뮬레이션, 사실적 AI 비디오, 텍스트 투 비디오, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - 플래그십 네이티브 AI 비디오 생성기 | WeryAI',
        description: 'WeryAI Video 1.0: 네이티브 멀티샷 내러티브, 스마트 이미지 투 비디오, 물리급 모션 시뮬레이션을 지원하는 플래그십 AI 비디오 모델.',
        keywords: 'WeryAI Video 1.0, WeryAI 네이티브 모델, AI 비디오 생성기, 멀티샷 내러티브, 이미지 투 비디오, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - 네이티브 AI 이미지 생성기 | WeryAI',
        description: 'WeryAI Image 2로 놀라운 네이티브 AI 이미지 생성! 플래그십 모델, 고급 스타일 제어와 디테일. 무료 크레딧, 카드 불필요.',
        keywords: 'WeryAI Image 2, 네이티브 AI 이미지 생성기, 플래그십 AI 이미지, 스튜디오급 AI, WeryAI Image 무료, WeryAI Image 2 사용법, WeryAI',
    },
    image_grok_2: {
        title: '무료 Grok 2 - xAI 이미지 생성기 | WeryAI',
        description: 'WeryAI에서 Grok 2로 창의적인 AI 이미지를 생성! xAI 모델, 예술적 유연성과 독특한 비주얼 스타일. 무료 크레딧, 카드 불필요.',
        keywords: 'Grok 2, Grok AI, xAI 이미지 생성, AI 아트, 창의적 AI 이미지, Grok 2 무료, Grok 2 사용법, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 이미지 생성기 | WeryAI',
        description: 'Nano Banana 2는 Gemini로 구동되어 세계 지식과 실시간 검색을 결합하여 사실적으로 정확하고 아름다운 이미지를 생성합니다. 초고속 생성, 최고의 가성비. WeryAI에서 지금 무료로 체험하세요.',
        keywords: 'Nano Banana 2, Google AI, Gemini, AI 이미지 생성기, 이미지 생성, 텍스트 투 이미지, 텍스트 렌더링, 다중 주체 일관성, 4K, WeryAI',
        og_title: 'Nano Banana 2 이미지 생성기 | WeryAI',
        og_description: 'Nano Banana 2는 Gemini로 구동되어 세계 지식과 실시간 검색을 결합하여 사실적으로 정확하고 아름다운 이미지를 생성합니다. 초고속 생성, 최고의 가성비. WeryAI에서 지금 무료로 체험하세요.',
        twitter_title: 'Nano Banana 2 이미지 생성기 | WeryAI',
        twitter_description: 'Nano Banana 2는 Gemini로 구동되어 세계 지식과 실시간 검색을 결합하여 사실적으로 정확하고 아름다운 이미지를 생성합니다. 초고속 생성, 최고의 가성비. WeryAI에서 지금 무료로 체험하세요.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 AI 이미지 생성기',
        twitterImageAlt: 'Nano Banana 2 AI 이미지 생성기',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo - 최고급 AI 비디오 생성기 | WeryAI',
        description: 'Kling 2.5 Turbo는 탁월한 카메라 워크 제어와 감정 표현력을 제공합니다. 영화급 AI 비디오 제작의 최적 선택.',
        keywords: 'Kling 2.5 Turbo, Kling AI, 영화급 비디오, 카메라 워크 제어, 비디오 생성, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - 전문 AI 비디오 편집 및 생성 | WeryAI',
        description: 'Runway Gen-4는 심층 프롬프트 이해와 스타일 일관성을 갖추고 있습니다. WeryAI에서 차세대 AI 비디오 편집을 경험하세요.',
        keywords: 'Runway Gen-4, Runway AI, 비디오 생성기, AI 비디오 편집, 텍스트 투 비디오, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 (MiniMax) - 이커머스 및 다이나믹 AI 비디오 | WeryAI',
        description: 'Hailuo 2.3은 다이나믹 액션과 이커머스 광고에 최적화되어 있습니다. 섬세한 얼굴 미세표정과 객체 모션 제어를 제공합니다.',
        keywords: 'Hailuo 2.3, Hailuo AI, MiniMax, 이커머스 비디오, 다이나믹 AI 비디오, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI 비디오 생성기 - 고급 모션 제어 | WeryAI',
        description: 'Hailuo AI로 고급 AI 비디오를 생성하세요. 최첨단 모션 시뮬레이션과 사실적인 씬 렌더링 기능을 갖추고 있습니다.',
        keywords: 'Hailuo AI, Hailuo AI, 모션 제어, 사실적 비디오, 비디오 생성기, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - 고화질 섬세한 AI 애니메이션 생성 | WeryAI',
        description: 'WeryAI에서 Pika 2.2를 경험하고 선명하고 날카로운 고화질 AI 애니메이션을 생성하세요. 정교한 캐릭터 제작에 매우 적합합니다.',
        keywords: 'Pika 2.2, Pika AI, AI 애니메이션, 고화질 비디오, 비디오 생성기, WeryAI',
    },
    seedance: {
        title: 'Seedance AI 비디오 생성기 - 댄스 및 모션 제작 | WeryAI',
        description: 'Seedance로 사실적이고 전문적인 AI 댄스 비디오를 생성하세요.',
        keywords: 'Seedance, AI 비디오, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - 감독급 AI 비디오 생성기 | WeryAI',

        description: 'weryai Werydance 2.0은 감독급 AI 비디오 생성 플래그십 모델입니다. 멀티모달 참조 입력, 정밀 지시 따르기, 내러티브 일관성과 물리 시뮬레이션을 지원합니다. WeryAI에서 무료.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, AI 비디오 생성기, 감독급 제어, 멀티모달 비디오, 물리 시뮬레이션, 립싱크, 텍스트 투 비디오, 무료 AI 비디오, WeryAI',

        og_title: 'Werydance 2.0 - 감독급 AI 비디오 생성기 | WeryAI',

        og_description: 'weryai Werydance 2.0은 감독급 AI 비디오 생성 플래그십 모델입니다. 멀티모달 참조 입력, 정밀 지시 따르기, 내러티브 일관성과 물리 시뮬레이션을 지원합니다. WeryAI에서 무료.',

        twitter_title: 'Werydance 2.0 - 감독급 AI 비디오 생성기 | WeryAI',

        twitter_description: 'weryai Werydance 2.0은 감독급 AI 비디오 생성 플래그십 모델입니다. 멀티모달 참조 입력, 정밀 지시 따르기, 내러티브 일관성과 물리 시뮬레이션을 지원합니다. WeryAI에서 무료.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    wan_2_6: {
        title: 'Wan 2.6 | Alibaba의 고급 AI 비디오 생성기 | WeryAI',
        description: 'Wan 2.6은 Alibaba의 최신 플래그십 멀티모달 AI 비디오 생성 모델로, 시네마틱 1080p 품질, 네이티브 오디오-비주얼 싱크, 스마트 멀티샷 내러티브 기능을 제공합니다. WeryAI에서 무료로 사용해보세요.',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, AI 비디오 생성기, 멀티모달 비디오 모델, 텍스트에서 비디오로, 이미지에서 비디오로, 오디오 싱크, WeryAI Wan 2.6',
    },
    image_gpt_4o: {
        title: '무료 GPT-4o - OpenAI 이미지 생성기 체험 | WeryAI',
        description: 'WeryAI에서 GPT-4o로 대화를 통해 이미지를 생성! OpenAI 정밀 텍스트 렌더링과 고품질 결과. 무료 크레딧, 카드 불필요.',
        keywords: 'GPT-4o, GPT-4o 이미지, OpenAI 이미지 생성, 대화형 AI 아트, GPT-4o 무료, GPT-4o 이미지 사용법, WeryAI',
    },
    image_nano_banana_pro: {
        title: '무료 Nano Banana Pro - AI 이미지 생성기 | WeryAI',
        description: 'WeryAI에서 Nano Banana Pro로 최고 품질의 AI 이미지! Midjourney 수준의 품질, 우수한 프롬프트 준수. 무료 크레딧, 카드 불필요.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google AI 이미지, 추론 AI 이미지, 4K AI 이미지, Nano Banana Pro 무료, Nano Banana Pro 사용법, WeryAI',
    },
    image_nano_banana: {
        title: '무료 Nano Banana - AI 이미지 생성기 | WeryAI',
        description: 'WeryAI에서 Nano Banana로 AI 이미지를 쉽게 제작! 다재다능하고 빠른 AI 이미지 모델. 무료 크레딧, 카드 불필요.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google AI 이미지, 빠른 AI 이미지, 캐릭터 일관성, Nano Banana 무료, Nano Banana 사용법, WeryAI',
    },
    image_flux: {
        title: '무료 FLUX - AI 이미지 생성기 체험 | WeryAI',
        description: 'WeryAI에서 FLUX로 놀라운 AI 이미지를 생성하세요! Stable Diffusion 팀이 제작, 뛰어난 화질과 스타일 제어. 무료 크레딧, 카드 불필요.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, AI 이미지 생성기, 텍스트 투 이미지, AI 아트, FLUX AI 이미지 생성, FLUX 무료, FLUX 사용법, WeryAI',
    },
    image_flux_kontext: {
        title: '무료 FLUX Kontext - 프로 AI 이미지 에디터 | WeryAI',
        description: 'WeryAI에서 FLUX Kontext로 프로 수준 AI 이미지 편집! 우수한 프롬프트 준수, 고급 타이포그래피, 다단계 편집. 무료 크레딧, 카드 불필요.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, AI 이미지 에디터, 프로 AI 이미지, 타이포그래피 AI, FLUX Kontext 무료, FLUX Kontext 사용법, WeryAI',
    },
    image_imagen: {
        title: '무료 Imagen 4 - Google AI 이미지 생성기 | WeryAI',
        description: 'WeryAI에서 Google Imagen 4로 포토리얼 AI 이미지를 생성! 다양한 스타일 제어와 정확한 텍스트 생성. 무료 크레딧, 카드 불필요.',
        keywords: 'Imagen 4, Google Imagen, Google AI 이미지, 텍스트 투 이미지, 포토리얼 AI, Imagen 무료, Imagen 4 사용법, WeryAI',
    },
    image_qwen_image: {
        title: '무료 Qwen Image - Alibaba AI 이미지 모델 | WeryAI',
        description: 'WeryAI에서 Qwen Image로 다국어 AI 아트를 생성! Alibaba 오픈소스 모델, 우수한 텍스트 렌더링. 무료 크레딧, 카드 불필요.',
        keywords: 'Qwen Image, Alibaba AI, 오픈소스 AI 이미지, 다국어 텍스트 렌더링, Qwen Image 무료, Qwen Image 사용법, WeryAI',
    },
    image_wan_ai: {
        title: '무료 Wan AI - Alibaba 이미지 생성기 체험 | WeryAI',
        description: 'WeryAI에서 Wan AI로 고충실도 AI 이미지를 제작! Alibaba 모델, 정밀 프롬프트 준수와 포토리얼 렌더링. 무료 크레딧, 카드 불필요.',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI 이미지, 텍스트 투 이미지, 포토리얼 AI, Wan AI 무료, Wan AI 사용법, WeryAI',
    },
    image_seendream: {
        title: '무료 Seedream 4.0 - ByteDance 이미지 AI | WeryAI',
        description: 'WeryAI에서 Seedream 4.0으로 초고속 AI 이미지 생성! ByteDance 모델, 다양한 예술 스타일과 배치 처리. 무료 크레딧, 카드 불필요.',
        keywords: 'Seedream, Seedream 4.0, ByteDance AI 이미지, 초고속 AI 이미지, 예술 스타일 AI, Seedream 무료, Seedream 사용법, WeryAI',
    },
    image_dreamina: {
        title: '무료 Dreamina 4.0 - 멀티모달 이미지 AI | WeryAI',
        description: 'WeryAI에서 Dreamina 4.0으로 멀티모달 AI 이미지 제작! 스케치 변환, 스타일 전이, 캐릭터 융합 지원. 무료 크레딧, 카드 불필요.',
        keywords: 'Dreamina 4.0, ByteDance AI 이미지, 멀티모달 AI 이미지, 스케치 변환, 스타일 전이, Dreamina 무료, Dreamina 4.0 사용법, WeryAI',
    },
    image_seedream_4_5: {
        title: '무료 Seedream 4.5 - ByteDance 이미지 AI | WeryAI',
        description: 'WeryAI에서 Seedream 4.5로 플래그십 AI 이미지 생성! ByteDance 최신, 정밀 타이포그래피와 다중 이미지 융합. 무료 크레딧, 카드 불필요.',
        keywords: 'Seedream 4.5, ByteDance AI 이미지, 플래그십 AI 이미지, 타이포그래피 렌더링, 다중 이미지 융합, Seedream 4.5 무료, Seedream 4.5 사용법, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 이미지 생성기 | WeryAI',
        description: 'Seedream 5.0은 ByteDance AI 비주얼 분야의 정점으로, 네이티브 8K 초정밀 화질, 궁극의 시맨틱 이해, 멀티 서브젝트 구도, 텍스트 렌더링 2.0을 지원합니다. WeryAI에서 무료 체험하세요.',
        keywords: 'Seedream 5.0, ByteDance, AI 이미지 생성기, 8K 이미지 생성기, 이미지 생성, 텍스트 투 이미지, 시맨틱 이해, 멀티 서브젝트 구도, 텍스트 렌더링, WeryAI',
        og_title: 'Seedream 5.0 이미지 생성기 | WeryAI',
        og_description: 'Seedream 5.0은 ByteDance AI 비주얼 분야의 정점으로, 네이티브 8K 초정밀 화질, 궁극의 시맨틱 이해, 멀티 서브젝트 구도, 텍스트 렌더링 2.0을 지원합니다. WeryAI에서 무료 체험하세요.',
        twitter_title: 'Seedream 5.0 이미지 생성기 | WeryAI',
        twitter_description: 'Seedream 5.0은 ByteDance AI 비주얼 분야의 정점으로, 네이티브 8K 초정밀 화질, 궁극의 시맨틱 이해, 멀티 서브젝트 구도, 텍스트 렌더링 2.0을 지원합니다. WeryAI에서 무료 체험하세요.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 AI 이미지 생성기',
        twitterImageAlt: 'Seedream 5.0 AI 이미지 생성기',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - 전문 트루 벡터 AI 그래픽 생성기 | WeryAI',
        description: 'Recraft V4 Vector는 Recraft.ai의 전문급 AI 벡터 그래픽 생성기로, 편집 가능한 SVG 트루 벡터를 생성하며 무손실 스케일링, 정밀한 타이포그래피, 브랜드 스타일 제어를 제공합니다. WeryAI에서 지금 무료로 체험하세요.',
        keywords: 'Recraft V4 Vector, AI 벡터 생성, SVG 생성기, 트루 벡터, 로고 디자인, UI 아이콘, 벡터 일러스트, Recraft, WeryAI',
    },
    image_midjourney: {
        title: '무료 Midjourney - AI 아트 생성기 체험 | WeryAI',
        description: 'WeryAI에서 Midjourney로 아티스틱한 AI 이미지를 제작! 놀라운 미학과 조명 품질로 유명. 무료 크레딧, 카드 불필요.',
        keywords: 'Midjourney, Midjourney AI, AI 아트 생성기, 아티스틱 AI 이미지, Midjourney 무료, Midjourney 대안, Midjourney 사용법, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI 비디오 생성기 - 영화급 비디오 제작 | WeryAI',
        description: 'WeryAI에서 Runway Gen-4.5를 사용하여 놀라운 비디오를 제작하세요. 자기회귀 확산 하이브리드 아키텍처로 정밀한 물리 시뮬레이션과 시간 일관성을 제공합니다.',
        keywords: 'Runway Gen-4.5, AI 비디오 생성기, 영화급 AI 비디오, 물리 시뮬레이션, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI 비디오 생성기 - 고품질 비디오 제작 | WeryAI',
        description: 'WeryAI에서 Kling 2.6 Pro를 사용하여 고품질 비디오를 생성하세요. 네이티브 오디오 비주얼 생성, 1080p 영화 품질, 우수한 프롬프트 준수 능력.',
        keywords: 'Kling 2.6 Pro, AI 비디오 생성기, 고품질 AI 비디오, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 비디오 생성기 - 정밀한 카메라 제어와 시작/끝 프레임 지원 | WeryAI',
        description: 'WeryAI에서 Dreamina 3.0(지멍 3.0)을 사용하여 영화급 AI 비디오를 생성하세요. 시작/끝 프레임 정밀 제어, 전문 카메라 워크와 1080p 고다이나믹 비디오 생성을 지원합니다.',
        keywords: 'Dreamina 3.0, 지멍3.0, AI 비디오 생성기, 카메라 제어, 시작끝 프레임 제어, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI 비디오 생성기 - 창의적 비디오 생성 | WeryAI',
        description: 'WeryAI에서 Kling O1 AI 비디오 생성기를 사용하여 창의력을 발휘하세요. 상상력이 풍부하고 독특한 비디오 콘텐츠 생성에 최적화되어 있습니다.',
        keywords: 'Kling O1, AI 비디오 생성기, 창의적 AI 비디오, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - 스마트 스토리보드 AI 비디오 생성기 | WeryAI',

        description: 'Kling 3.0은 Kuaishou의 차세대 AI 비디오 플래그십 모델입니다. 스마트 스토리보드, 다국어 립싱크, 정밀 텍스트 렌더링, 15초 롱 생성을 지원합니다. WeryAI에서 무료 체험하세요.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, AI 비디오 생성기, 스마트 스토리보드, 다국어 립싱크, 텍스트 렌더링, 텍스트 투 비디오, 이미지 투 비디오, 무료 AI 비디오, WeryAI',

        og_title: 'Kling 3.0 - 스마트 스토리보드 AI 비디오 생성기 | WeryAI',

        og_description: 'Kling 3.0은 Kuaishou의 차세대 AI 비디오 플래그십 모델입니다. 스마트 스토리보드, 다국어 립싱크, 정밀 텍스트 렌더링, 15초 롱 생성을 지원합니다. WeryAI에서 무료 체험하세요.',

        twitter_title: 'Kling 3.0 - 스마트 스토리보드 AI 비디오 생성기 | WeryAI',

        twitter_description: 'Kling 3.0은 Kuaishou의 차세대 AI 비디오 플래그십 모델입니다. 스마트 스토리보드, 다국어 립싱크, 정밀 텍스트 렌더링, 15초 롱 생성을 지원합니다. WeryAI에서 무료 체험하세요.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - 16초 네이티브 오디오비디오 AI 생성기 | WeryAI',

        description: 'Vidu Q3는 세계 최초 16초 네이티브 오디오비디오 모델입니다. 스마트 컷 자동 편집, 중영일 정밀 텍스트 렌더링, 다국어 립싱크를 지원합니다. WeryAI에서 무료 체험하세요.',

        keywords: 'Vidu Q3, Vidu AI, AI 비디오 생성기, 16초 오디오비디오, 네이티브 오디오비디오, 스마트 스토리보드, 텍스트 렌더링, 립싱크, 텍스트 투 비디오, 무료 AI 비디오, WeryAI',

        og_title: 'Vidu Q3 - 16초 네이티브 오디오비디오 AI 생성기 | WeryAI',

        og_description: 'Vidu Q3는 세계 최초 16초 네이티브 오디오비디오 모델입니다. 스마트 컷 자동 편집, 중영일 정밀 텍스트 렌더링, 다국어 립싱크를 지원합니다. WeryAI에서 무료 체험하세요.',

        twitter_title: 'Vidu Q3 - 16초 네이티브 오디오비디오 AI 생성기 | WeryAI',

        twitter_description: 'Vidu Q3는 세계 최초 16초 네이티브 오디오비디오 모델입니다. 스마트 컷 자동 편집, 중영일 정밀 텍스트 렌더링, 다국어 립싱크를 지원합니다. WeryAI에서 무료 체험하세요.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_image_1_5: {
        title: '무료 GPT Image 1.5 - OpenAI 아트 생성기 | WeryAI',
        description: 'WeryAI에서 GPT Image 1.5로 차세대 AI 아트를 제작! OpenAI 최신 이미지 모델, 창의성과 디테일 향상. 무료 크레딧, 카드 불필요.',
        keywords: 'GPT Image 1.5, OpenAI 이미지 모델, AI 아트 생성기, 차세대 AI 이미지, GPT Image 1.5 무료, GPT Image 1.5 사용법, WeryAI',
    },
}
